import React from 'react';

import ProductTableWrapper from "../Components/ProductTableWrapper";

const ProductDetailsContainer = ({productGroupHeadings, productGroupTitle, selectVersion, urlIconCar, productGroupId, contactDetails}) => {
    const productGroupHeadingsParsed = JSON.parse(productGroupHeadings);
    const productGroupTitleParsed = JSON.parse(productGroupTitle);
    const selectVersionParsed = JSON.parse(selectVersion);
    const productGroupIdParsed = productGroupId ? Number.parseInt(productGroupId) : 0;
    const contactDetailsParsed = JSON.parse(contactDetails);

    return <ProductTableWrapper
        productGroupHeadings={productGroupHeadingsParsed}
        productGroupTitle={productGroupTitleParsed}
        selectVersion={selectVersionParsed}
        urlIconCar={urlIconCar}
        productGroupIdActive={productGroupIdParsed}
        contactDetails={contactDetailsParsed}
    />
}

export default ProductDetailsContainer;
